import { FC, memo, useCallback, useContext } from 'react';
import styled from 'styled-components';
import { ReactComponent as PointIcon } from '../../../assets/point.svg';
import { PageContext } from '../../../context/context';
import { IAppointment } from '../../appointment/appointment';
import { AlertKeys } from '../Alert/Alert.types';
import CustomButton from '../CustomButton/CustomButton';
import { StyledStatusType } from './Card.types';

const Card: FC<IAppointment> = () => {
    const { setAlert, setId, data } = useContext(PageContext);
    const {
        schedid,
        status,
        patient,
        birthday,
        date,
        time,
        price,
        filial,
        doctor,
        ext_avatar,
        ext_speciality,
    } = data;
    const PointIconMemo = memo(PointIcon);

    console.log(status);

    const onHandleTransfer = useCallback(() => {
        setId(schedid);
        setAlert(AlertKeys.transfer);
    }, [setAlert, setId]);

    const onHandleCancel = useCallback(() => {
        setId(schedid);
        setAlert(AlertKeys.cancel);
    }, [setAlert, setId]);

    return (
        <StyledCard>
            <StyledCardStatus $status={status}>
                {status === 'reserved'
                    ? 'Активная'
                    : status === 'moving'
                    ? 'Перенесена'
                    : 'Отменена'}
            </StyledCardStatus>
            <StyledCardPatientName>
                {`${patient && patient}, ${birthday && birthday}`}
            </StyledCardPatientName>
            {/* <StyledCardTitle>{title && title}</StyledCardTitle> */}
            <StyledCardDate>{`${date && date} | ${
                time && time
            }`}</StyledCardDate>
            <StyledCardDoctor>
                <img
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src =
                            'https://mc21.ru/upload/medialibrary/7b0/nvuhv8sp88ejr2w7d62fa7ss0rgikp7q.png';
                    }}
                    src={ext_avatar}
                    alt={doctor}
                />
                <div>
                    <p>{doctor && doctor}</p>
                    <small>{ext_speciality && ext_speciality}</small>
                </div>
            </StyledCardDoctor>
            <StyledCardAddress>
                <PointIconMemo />
                <div>
                    <p>{filial && filial}</p>
                </div>
            </StyledCardAddress>
            <StyledCardPrice>
                {price !== 0 && `${price} рублей`}
            </StyledCardPrice>
            {status === 'reserved' && (
                <StyledButtonsWrapper>
                    <CustomButton onClick={onHandleTransfer} type="primary">
                        Перенести прием
                    </CustomButton>
                    <CustomButton onClick={onHandleCancel} type="secondary">
                        Отменить прием
                    </CustomButton>
                </StyledButtonsWrapper>
            )}
            <p>Управляйте своими записями быстро и удобно в личном кабинете</p>
            <a href="https://mc21.ru/lk">Перейти в личный кабинет</a>
        </StyledCard>
    );
};

const StyledCard = memo(styled.div`
    flex-grow: 1;
    animation: fade 0.3s linear;
    position: relative;
    padding: 40px 157px 52px 79px;
    border-radius: 2px;
    background: #fff;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
    width: 100%;
    @media (max-width: 840px) {
        padding: 40px 32px 52px 32px;
    }
    @media (max-width: 667px) {
        padding: 24px 15px 24px 15px;
    }
    && p {
        font-weight: 600;
        font-size: 16px;
        line-height: 120%;
        text-align: center;
        margin-bottom: 16px;
        text-align: left;
        padding: 0;
    }
    && a {
        font-weight: 700;
        font-size: 16px;
        line-height: 120%;
        text-decoration: underline;
        text-decoration-skip-ink: none;
        color: #82bf31;
        &:hover {
            opacity: 0.8;
        }
    }
`);
const StyledCardPatientName = memo(styled.div`
    color: #747f8f;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    margin-bottom: 32px;
    @media (max-width: 667px) {
        margin-top: 44px;
        margin-bottom: 20px;
        font-size: 14px;
    }
`);
const StyledCardStatus = memo(styled.div<StyledStatusType>`
    position: absolute;
    right: 17px;
    top: 37px;
    color: ${({ $status }) => ($status === 'reserved' ? '#82bf31' : '#FF9211')};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    @media (max-width: 667px) {
        top: 24px;
        right: none;
        left: 15px;
    }
`);

const StyledCardDate = memo(styled.div`
    color: #172945;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
    text-transform: uppercase;
    margin-bottom: 24px;
    @media (max-width: 667px) {
        margin-bottom: 16px;
        font-size: 14px;
    }
`);
const StyledCardDoctor = memo(styled.div`
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    gap: 7px;
    @media (max-width: 667px) {
        margin-bottom: 16px;
    }
    div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        p {
            color: #172945;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 150%;
            padding: 0;
            margin-bottom: 4px;
            text-align: left;
            @media (max-width: 667px) {
                font-size: 14px;
            }
        }
        small {
            color: #172945;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
        }
    }
    img {
        display: block;
        width: 57px;
        height: 57px;
        border-radius: 100%;
        box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
    }
`);
const StyledCardAddress = memo(styled.div`
    margin-bottom: 24px;
    display: flex;
    gap: 7px;
    align-items: flex-start;
    div {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        & > p {
            color: #172945;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 150%;
            margin-bottom: 4px;
            padding: 0;
            text-align: left;
        }
        & > small {
            color: #172945;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
        }
    }
`);
const StyledCardPrice = memo(styled.div`
    margin-bottom: 32px;
    color: #82bf31;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 160%;
    @media (max-width: 667px) {
        font-size: 16px;
        margin-bottom: 24px;
    }
`);
const StyledButtonsWrapper = memo(styled.div`
    display: flex;
    justify-content: flex-start;
    gap: 24px;
    margin-bottom: 16px;

    @media (max-width: 667px) {
        flex-direction: column;
        gap: 16px;
    }
`);

export default memo(Card);
